import { ReactNode } from 'react';
import * as S from './styles';

export type IconItemProps = {
  icon: ReactNode;
  text: ReactNode;
};

const IconItem = ({ icon, text }: IconItemProps) => (
  <S.Wrapper aria-label="icon item">
    {icon}
    {text}
  </S.Wrapper>
);

export default IconItem;
